import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import AnnouncementBar from './src/components/AnnouncementBar';
import ChewingGumThinBanner from './src/components/ChewingGumThinBanner';
import HomepageBanner from './src/components/HomepageBanner';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'announcement-bar',
        component: AnnouncementBar,
      },

      {
        key: 'custom-home-page-hero-banner',
        component: HomepageBanner,
      },

      {
        key: 'custom-chewing-gum-thin-banner',
        component: ChewingGumThinBanner,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
